<template>
	<div class="related-business" :style="{'margin-left': marginLeft}">
		<!-- 关联业务 -->
		<el-popover 
			v-if="alterable"
			v-model="showPopover" 
			placement="bottom" 
			width="800"
			popper-class="no-padding-popover" 
			trigger="click">
			<crm-relative-all 
				v-if="showRelative"
				ref="crmrelative"
				:show="showPopover"
				:radio="false"
				:selectedData="relatedListData"
				:showTypes='showTypes'
				@close="crmrelativeClose"
				@changeCheckout="checkInfos">
			</crm-relative-all>
			<p 
				class="add-file" 
				slot="reference" 
				@click="showRelative = true">
				<img src="@/assets/img/relevance_business.png" alt="">
				关联业务
			</p>
		</el-popover>
		<div v-for="(items, key) in relatedListData"
			 :key="key" style="margin-left: 70px;">
			<crm-relative-all-cell 
				v-for="(item, itemIndex) in items"
				:data="item"
				:cellIndex="itemIndex"
				:type="key"
				:key="itemIndex"
				@detail="checkRelatedDetail(key, item)">
		  </crm-relative-all-cell>
		</div>
	</div>
</template>

<script>
	import CrmRelativeAll from '@/components/CreateCom/CrmRelativeAll'
	import CrmRelativeAllCell from '@/components/CreateCom/CrmRelativeAllCell'
	export default {
		components: {
			CrmRelativeAll,
			CrmRelativeAllCell
		},
		data() {
			return {
				showPopover: false,
				showRelative: false,
				// 关联业务信息
				relatedListData: {},
				showTypes: ['customer', 'lawcase', 'contract'],
				relevanceAll: {
					customer_ids: [],
					contract_ids: [],
					lawcase_ids: [],
				},
			}
		},
		watch: {
			allData: function(value) {
				this.relatedListData = this.allData
			}
		},
		props: {
			marginLeft: {
				type: String,
				default: '20px'
			},
			// 编辑时传递所有关联数据   关联客户-customer 关联案件-lawcase 顾问-contract
			allData: {
				type: Object,
				default: () => {
					return {
						customer: [],
						lawcase: [],
						contract: []
					}
				}
			},
			alterable: {
				type: Boolean,
				default: true
			},
			alterableColor: {
				type: String,
				default: '#999'
			}
		},
		mounted() {
			// 编辑时勾选
			this.relatedListData = this.allData
		},
		methods: {
			crmrelativeClose() {
				this.showPopover = false
			},
			
			checkInfos(val) {
				this.showPopover = false
				this.relatedListData = val.data
				
				for (let key in val.data) {
					const list = val.data[key]
					this.relevanceAll[key + '_ids'] = list.map(function(
						item,
						index,
						array
					) {
						return item['id']
					})
				}
				
				this.$emit('checkInfos', this.relevanceAll)
			},
			
			checkRelatedDetail(field, val) {
				val.key = val[field + '_id']
				this.$emit('checkRelatedDetail', field, val)
			}
		}
	}
</script>

<style scoped lang="scss">
	.related-business {
		color: #777;
		font-size: 12px;
		margin: 10px 0;
		.alterable-p {
			padding-bottom: 10px;
			font-size: 13px;
			width: 70px;
		}
	}
	.add-file {
		margin: 10px 0;
		font-size: 13px;
		color: #3e84e9;
		cursor: pointer;
		display: inline-block;
		img {
			vertical-align: middle;
			width: 15px;
			margin-right: 5px;
		}
	}
</style>